import {useGetAndSet} from "./useGetAndSet";
import {createSetPaymentTypesDataAction} from "../actions/dataActions";

export const usePaymentTypesData = (params, dataFresh) => {
    return useGetAndSet("paymenttype", params, createSetPaymentTypesDataAction, dataFresh);
}